import { render, staticRenderFns } from "./ReferenceChildren.vue?vue&type=template&id=7d27b30a&scoped=true&"
import script from "./ReferenceChildren.vue?vue&type=script&lang=ts&"
export * from "./ReferenceChildren.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d27b30a",
  null
  
)

export default component.exports